import React, { useState } from "react";
import { DefaultImg } from "../images";
import { useTranslation } from "react-i18next";
import "./style.scss";
import StoreMapDetailModal from "../storeMapDetailModal";

const StoreAgencyListItem = (props: any) => {
  const { key, store } = props;
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState<any>({});

  const showModal = () => {
    setIsModalVisible({ ...isModalVisible, [store._id]: true });
  };

  const handleClose = () => {
    setIsModalVisible({ ...isModalVisible, [store._id]: false });
  };

  return (
    // <div>
    <React.Fragment key={key}>
      <div className="store-item-container" onClick={showModal}>
        <div className="store-item-image">
          <img src={store.img_url ? store.img_url : DefaultImg} />
        </div>
        <div className="store-item-info">
          <span className="sub-content">
            {store.is_agency
              ? t("store_filter_type_agency")
              : t("store_filter_type_store")}
          </span>
          <span className="sub-content address">{store.address}</span>
        </div>
      </div>
      {isModalVisible[store._id] && (
        <StoreMapDetailModal
          id={store._id}
          isModalVisible={isModalVisible[store._id]}
          handleClose={handleClose}
        />
      )}
    </React.Fragment>
    // </div>
  );
};

export default StoreAgencyListItem;
